<template>
  <q-form id="popup_form" ref="form" :model="formModel" :rules="rules">
    <p>Вы должны быть приглашены ведущим ранее и зарегистрированы, чтобы войти.</p>
    <q-form-item prop="email" label="E-mail" type="email" required>
      <q-input v-model="formModel.email" />
    </q-form-item>
    <q-form-item prop="password" label="Пароль" required>
      <q-input v-model="formModel.password" type="password"  showPassword />
    </q-form-item>

    <q-button :loading="isSending" @click="handleSendClick">Войти</q-button>

    <q-button theme="secondary" @click="handleCancelClick">Отменить</q-button>
  </q-form>
</template>

<script>
export default {
  data() {
    return {
      isSending: false,
      formModel: {
        email: "test",
        password: "test"
      },
      rules: {
        email: {
          required: true,
          message: "Введите ваш e-mail",
          trigger: "blur"
        },
        password: {
          required: true,
          message: "Введите ваш пароль",
          trigger: "blur"
        }

      }
    };
  },
  methods: {
    handleCancelClick() {
      this.$emit("close", { action: "cancel" });
    },
    async handleSendClick() {
      this.isSending = true;
      const promise = () =>
        new Promise(resolve => {
          setTimeout(() => resolve("done"), 1000);
        });
      try {
        const payload = await promise();
        this.$emit("close", { action: "confirm", payload });
      } catch (error) {
        console.log(error);
      }
      this.isSending = false;
    }
  }
};
</script>
<style scoped>
#popup_form {
  padding: 0 30px 30px 30px;
}
</style>